import React from "react";
import { Backdrop, Box } from "@mui/material";
import theme from "../../theme";

interface Props {
  open: boolean;
}

const BackdropLoader: React.FC<Props> = (props) => {
  const { open } = props;
  return (
    <Backdrop
      sx={{
        zIndex: theme.zIndex.drawer + 2,
        backgroundColor: "rgba(38,84,158,0.5)",
      }}
      open={open}
    >
      <Box
        sx={{
          fontSize: "100px",
          position: "absolute",
          overflow: "hidden",
          display: "inline-block",
          animation: "blink 2s infinite linear",
          "@keyframes blink": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.1 },
          },
        }}
      >
        <img height={150} src={"/static/images/SVPro.png"} alt="logo" />
      </Box>
    </Backdrop>
  );
};

export default BackdropLoader;
